import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Image } from '@outdoor-voices/ui';
import { memo, useContext } from 'react';
import cc from 'classcat';
import PropTypes from 'prop-types';
import { KitContext } from './context';
import css from './ProductSelect.module.scss';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ProductSelect = /*#__PURE__*/memo(function (_ref) {
  var options = _ref.options,
      onProductSelect = _ref.onProductSelect,
      value = _ref.value;

  var _useContext = useContext(KitContext),
      step = _useContext.step;

  if (options.length < 2) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }

  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    children: [/*#__PURE__*/_jsxs("div", {
      className: css.label,
      id: "product-select-label",
      children: ["Choose between ", options.length, " items:"]
    }), /*#__PURE__*/_jsx("div", {
      className: cc([css.options, _defineProperty({}, css.centered, options.length < 4)]),
      role: "radiogroup",
      "aria-labelledby": "product-select-label",
      children: options.map(function (_ref3) {
        var _colorway$assets, _colorway$assets2;

        var colorwayId = _ref3.colorwayId,
            product = _ref3.product;
        var colorway = (product.colorways.edges.find(function (_ref4) {
          var node = _ref4.node;
          return node.id === colorwayId;
        }) || product.colorways.edges[0]).node;
        var asset = (colorway === null || colorway === void 0 ? void 0 : (_colorway$assets = colorway.assets) === null || _colorway$assets === void 0 ? void 0 : _colorway$assets.edges.find(function (_ref5) {
          var node = _ref5.node;
          return node.type === 'VIEWS';
        })) || (colorway === null || colorway === void 0 ? void 0 : (_colorway$assets2 = colorway.assets) === null || _colorway$assets2 === void 0 ? void 0 : _colorway$assets2.edges[0]);
        return /*#__PURE__*/_jsxs("button", {
          // eslint-disable-next-line max-len
          "aria-label": "Click to change the step ".concat(step, " product in your kit to ").concat(product.title, " and select color and size options"),
          "aria-checked": value === product.id,
          className: css.option,
          onClick: function onClick() {
            onProductSelect(colorway.id, product.id);
          },
          type: "button",
          role: "radio",
          children: [/*#__PURE__*/_jsx("div", {
            className: css.image,
            children: /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, asset.node.image), {}, {
              size: [104]
            }))
          }), /*#__PURE__*/_jsx("div", {
            className: cc([css.productTitle, _defineProperty({}, css.on, product.id === value)]),
            children: product.title
          })]
        }, product.id);
      })
    })]
  });
});
ProductSelect.propTypes = {
  onProductSelect: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({})),
  value: PropTypes.string
};